import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { auth, idToken } from "components/firebase";

const setAuthToken = (token) => {
  delete axios.defaults.headers.common["Authorization"];
  if (token) {
    // Apply to every request
    axios.defaults.headers.common["Authorization"] = idToken;
  }
};

// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) =>
  auth?.currentUser?.getIdToken(true).then((token) => {
    localStorage.setItem("StipplToken", token);
    failedRequest.response.config.headers["Authorization"] = token;
    return Promise.resolve();
  });

createAuthRefreshInterceptor(axios, refreshAuthLogic);

export default setAuthToken;
